import { Injectable, EventEmitter, Output, Inject, PLATFORM_ID, Directive } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { isPlatformBrowser } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { Location } from '@angular/common';
import { filter } from "rxjs/operators";
import { SeoService } from "./seo.service";
interface ProductsArrInterface {
  name: string;
  id: number;
  price: number;
  brand: string;
  quantity: number;
}


@Directive()
@Injectable({
  providedIn: "root"
})
export class DataService {
  headerUpdated: EventEmitter<any> = new EventEmitter<any>();
  dataUpdated: EventEmitter<any> = new EventEmitter<any>();
  filterUpdated: EventEmitter<any> = new EventEmitter<any>();
  categoriesUpdated: EventEmitter<any> = new EventEmitter<any>();
  refreshData: EventEmitter<any> = new EventEmitter<any>();
  performLoginTrigger: EventEmitter<any> = new EventEmitter<any>();
  showCartPopupTrigger: EventEmitter<any> = new EventEmitter<any>();
  popupCloseTrigger: EventEmitter<any> = new EventEmitter<any>();
  popupOkTrigger: EventEmitter<any> = new EventEmitter<any>();
  @Output() showCartMobileTrigger: EventEmitter<any> = new EventEmitter<any>();
  makesLoaded: EventEmitter<any> = new EventEmitter<any>();
  showOrderStatusTrigger: EventEmitter<any> = new EventEmitter<any>();
  showPopUpInHomePageTrigger: EventEmitter<any> = new EventEmitter<any>();

  showChatPopupTrigger: EventEmitter<any> = new EventEmitter<any>();
  activeChatPopupTrigger: EventEmitter<any> = new EventEmitter<any>();
   linkClickedSource = new Subject<any>();
  linkClicked$ = this.linkClickedSource.asObservable();


  isBrowser: boolean = false;
  loadingCategories: boolean = false;


  public data: any = {};
  public partType: any = {};
  public filter: any = {};
  public categories: any = [];
  public makes: any = [];
  public zipCode: any = null;
  public shippingOptions: any = [];
  statusChange: Subject<any> = new Subject<any>();
  reviewsData: Subject<any> = new Subject<any>();
  orderData: any;
  public yearData = [{"id":90,"year":"1928"},{"id":87,"year":"1929"},{"id":88,"year":"1930"},{"id":91,"year":"1931"},{"id":92,"year":"1932"},{"id":93,"year":"1933"},{"id":94,"year":"1934"},{"id":89,"year":"1935"},{"id":84,"year":"1936"},{"id":85,"year":"1937"},{"id":86,"year":"1938"},{"id":80,"year":"1939"},{"id":81,"year":"1940"},{"id":82,"year":"1941"},{"id":78,"year":"1942"},{"id":77,"year":"1943"},{"id":76,"year":"1944"},{"id":75,"year":"1945"},{"id":74,"year":"1946"},{"id":73,"year":"1947"},{"id":72,"year":"1948"},{"id":71,"year":"1949"},{"id":70,"year":"1950"},{"id":69,"year":"1951"},{"id":68,"year":"1952"},{"id":65,"year":"1953"},{"id":64,"year":"1954"},{"id":63,"year":"1955"},{"id":62,"year":"1956"},{"id":67,"year":"1957"},{"id":66,"year":"1958"},{"id":61,"year":"1959"},{"id":47,"year":"1960"},{"id":46,"year":"1961"},{"id":45,"year":"1962"},{"id":44,"year":"1963"},{"id":51,"year":"1964"},{"id":43,"year":"1965"},{"id":42,"year":"1966"},{"id":41,"year":"1967"},{"id":40,"year":"1968"},{"id":39,"year":"1969"},{"id":38,"year":"1970"},{"id":37,"year":"1971"},{"id":36,"year":"1972"},{"id":35,"year":"1973"},{"id":34,"year":"1974"},{"id":59,"year":"1975"},{"id":58,"year":"1976"},{"id":57,"year":"1977"},{"id":50,"year":"1978"},{"id":49,"year":"1979"},{"id":48,"year":"1980"},{"id":54,"year":"1981"},{"id":53,"year":"1982"},{"id":52,"year":"1983"},{"id":56,"year":"1984"},{"id":55,"year":"1985"},{"id":32,"year":"1986"},{"id":31,"year":"1987"},{"id":30,"year":"1988"},{"id":29,"year":"1989"},{"id":28,"year":"1990"},{"id":27,"year":"1991"},{"id":26,"year":"1992"},{"id":25,"year":"1993"},{"id":24,"year":"1994"},{"id":23,"year":"1995"},{"id":22,"year":"1996"},{"id":6,"year":"1997"},{"id":5,"year":"1998"},{"id":4,"year":"1999"},{"id":15,"year":"2000"},{"id":3,"year":"2001"},{"id":2,"year":"2002"},{"id":1,"year":"2003"},{"id":14,"year":"2004"},{"id":13,"year":"2005"},{"id":10,"year":"2006"},{"id":9,"year":"2007"},{"id":8,"year":"2008"},{"id":7,"year":"2009"},{"id":11,"year":"2010"},{"id":12,"year":"2011"},{"id":33,"year":"2012"},{"id":18,"year":"2013"},{"id":17,"year":"2014"},{"id":16,"year":"2015"},{"id":21,"year":"2016"},{"id":20,"year":"2017"},{"id":19,"year":"2018"},{"id":60,"year":"2019"},{"id":79,"year":"2020"},{"id":83,"year":"2021"},{"id":95,"year":"2022"},{"id":96,"year":"2023"}];
  yearMakeModelData: Subject<{ status: any, array: any, index: any, datasection: any, showDrop: any }> = new Subject<{ status: any, array: any, index: any, datasection: any, showDrop: any }>();
  setVehicleData: Subject<{ data: any, id: any }> = new BehaviorSubject(null);
  yearNamesAndIds: Subject<any> = new BehaviorSubject(null);
  showAddVehicleData: Subject<any> = new Subject<any>(); 
  emitPartTypeData: Subject<any> = new Subject<any>();
  siteReviewsData: Subject<any> = new Subject<any>();


  floatingToolbar: Subject<any> = new Subject<any>();
  floatingToolbarDestroy: Subject<any> = new Subject<any>();



  // All Products

  
  closeCheckFitment: Subject<any> = new Subject<any>();
  savedAddVehicle = null;
  isVehicleAdded: Boolean = false;
  updateListWithYMK: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  currentUrl = '';
  updateAddVehicles: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  initiateLoginPopup: Subject<any> = new Subject<any>();

  paramsForRelatedParts = new Subject<any>();
  

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private http: HttpClient,
    private router: Router,
    private location: Location,
    private seoService: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.url;
    });

  }

  getParamsForRelatedParts(data: any){
      this.paramsForRelatedParts.next(data);
  }


  getSliderData() {
    let baseURL = AppConstants.baseURL.replace(/(user)(?!.*user)/, 'admin');
    return this.http.get(baseURL + AppConstants.URL_HEADER_SLIDER);
  }

  getPartTypeData() {
    let baseURL = AppConstants.baseURL.replace(/(user)(?!.*user)/, 'admin');
    return this.http.get(baseURL + AppConstants.URL_HOME_POPULAR_PART_TYPE);
  }

  getPopularBrandsData() {
    return this.http.get(AppConstants.baseURL + AppConstants.URL_FOOTER_POPULAR_BRAND);
  }

  getPopularPartsData() {
    let baseURL = AppConstants.baseURL.replace(/(user)(?!.*user)/, 'admin');
    return this.http.get(baseURL + AppConstants.URL_FOOTER_POPULAR_PARTS);
  }

  getPopularPartsOfBrand(pageType: string, part_kit_id: string, year_id?, make_id?, model_id?) {
    let url = "",  params = "?";
    url = pageType == 'kit' ? `kit_details/get_related_parts` : `part_details/get_related_parts`;
    if (part_kit_id) {
      params = params.concat("id=" + part_kit_id);
    }
    if (year_id) {
      params = params.concat("&year_id=" + year_id);
    }
    if (make_id) {
      params = params.concat("&make_id=" + make_id);
    }
    if (model_id) {
      params = params.concat("&model_id=" + model_id);
    }
    return this.http.get(AppConstants.baseURL+url+params);
  }


  getHeaderSearch(searchText?) {
    let params = "?";
    if (searchText) {
      params = params.concat("search_text=" + searchText);
    }
    return this.http.get(AppConstants.baseURL + AppConstants.URL_HOME_HEADER_SEARCH + params);
  }

  applyHomeFilter(year?, make?, model?,) {
    let params = "?";
    if (year) {
      params = params.concat("year=" + year);
    }
    if (make) {
      params = params.concat("&make=" + make);
    }
    if (model) {
      params = params.concat("&model=" + model);
    }
    return this.http.get(AppConstants.baseURL + AppConstants.URL_HOME_APPLICATION_FILTER + params);
  }

  callGetYearMakeModel() {
    this.getYearMakeModel(0, 0, false);
  }

  getYearMakeModel(index, section, showDrop, year?, make?, model?,): void {
    this.applyHomeFilter(year, make, model).subscribe((response) => {
      if (response['status'] == 20 && response['data']) {
        if (index == 0) {
          this.yearData = response['data']['response'];
        }
        this.yearMakeModelData.next({ status: 1, array: response['data']['response'], index: index, datasection: section, showDrop: showDrop });
      } else {
        this.yearMakeModelData.next({ status: 0, array: [], index: index, datasection: section, showDrop: showDrop });
      }
    }, err => {
      this.yearMakeModelData.next({ status: -1, array: [], index: index, datasection: section, showDrop: showDrop });
    });
  }

  getYearData() {
    return this.yearData ? this.yearData : [];
  }

  // Add Vechicle

  getAddedVehicleData() {
    let params = "?";
    let headers = {};
    let accessToken = localStorage.getItem("access_token");
    let session_id = localStorage.getItem("add_vehicle_session_id") ? JSON.parse(localStorage.getItem("add_vehicle_session_id")) : null;
    if (accessToken) {
      headers = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Auth": `Bearer ${accessToken}`
        })
      }

    } else {
      if (session_id) {
        params = params.concat("session_id=" + session_id);
      }
    }
    if (headers && Object.keys(headers).length > 0) {
      return this.http.get(AppConstants.baseURL + AppConstants.URL_GET_POST_PUT_VEHICLE_ADD, headers);
    } else {
      return this.http.get(AppConstants.baseURL + AppConstants.URL_GET_POST_PUT_VEHICLE_ADD + params);
    }

  }

  postAddedVehicleData(year_id, make_id, model_id) {
    let headers, data = {};
    let accessToken = localStorage.getItem("access_token");
    let session_id = localStorage.getItem("add_vehicle_session_id") ? JSON.parse(localStorage.getItem("add_vehicle_session_id")) : null;
    if (accessToken) {
      headers = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Auth": `Bearer ${accessToken}`
        })
      }
    } else {
      if (session_id) {
        data["session_id"] = session_id;
      }
    }
    if (year_id) {
      data["year"] = year_id;
    }
    if (make_id) {
      data["make"] = make_id;
    }
    if (model_id) {
      data["model"] = model_id;
    }

    if (headers && Object.keys(headers).length > 0) {
      return this.http.post(AppConstants.baseURL + AppConstants.URL_GET_POST_PUT_VEHICLE_ADD, data, headers);
    } else {
      return this.http.post(AppConstants.baseURL + AppConstants.URL_GET_POST_PUT_VEHICLE_ADD, data);
    }
  }

  putAddedVehicle(id) {
    let headers, data = {};
    let accessToken = localStorage.getItem("access_token");
    let session_id = localStorage.getItem("add_vehicle_session_id") ? JSON.parse(localStorage.getItem("add_vehicle_session_id")) : null;
    if (accessToken) {
      headers = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Auth": `Bearer ${accessToken}`
        })
      }
    } else {
      if (session_id) {
        data["session_id"] = session_id;
      }
    }
    data['is_selected'] = true;
    if (headers && Object.keys(headers).length > 0) {
      return this.http.put(AppConstants.baseURL + AppConstants.URL_GET_POST_PUT_VEHICLE_ADD + `/${id}`, data, headers);
    } else {
      return this.http.put(AppConstants.baseURL + AppConstants.URL_GET_POST_PUT_VEHICLE_ADD + `/${id}`, data);
    }
  }

  deleteAddedVehicle(id) {
    let accessToken = localStorage.getItem("access_token");
    let session_id = localStorage.getItem("add_vehicle_session_id") ? JSON.parse(localStorage.getItem("add_vehicle_session_id")) : null;
    const options = {
      headers: accessToken ? new HttpHeaders({
        "Content-Type": "application/json",
        "Auth": `Bearer ${accessToken}`
      }) : null,
      body: session_id ? { session_id: session_id } : null
    };
    return this.http.delete(
      AppConstants.baseURL + AppConstants.URL_GET_POST_PUT_VEHICLE_ADD + `/${id}`,
      options
    );

  }


  clearAllAddedVehicle() {
    let accessToken = localStorage.getItem("access_token");
    let session_id = localStorage.getItem("add_vehicle_session_id") ? JSON.parse(localStorage.getItem("add_vehicle_session_id")) : null;
    const options = {
      headers: accessToken ? new HttpHeaders({
        "Content-Type": "application/json",
        "Auth": `Bearer ${accessToken}`
      }) : null,
      body: session_id ? { session_id: session_id } : null
    };
    return this.http.delete(AppConstants.baseURL + AppConstants.URL_GET_POST_PUT_VEHICLE_ADD_CLEAR_ALL, options);
  }

  mergeAddedVehicle(vehicleIds) {
    let headers, data = {};
    let accessToken = localStorage.getItem("access_token");
    let session_id = localStorage.getItem("add_vehicle_session_id") ? JSON.parse(localStorage.getItem("add_vehicle_session_id")) : null;
    headers = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Auth": `Bearer ${accessToken}`
      })
    }
    data["session_id"] = session_id ? session_id : null;
    data["vehicles"] = vehicleIds && vehicleIds.length > 0 ? vehicleIds : [];
    return this.http.post(AppConstants.baseURL + AppConstants.URL_MERGE_ADD_VEHICLE, data, headers);
  }

  setAddSearchLocalValues(year?, make?, model?) {
    const search = {
      year: year && Object.keys(year).length > 0 ? year : "",
      make: make && Object.keys(make).length > 0 ? make : "",
      model: model && Object.keys(model).length > 0 ? model : "",
      id: year.id + '-' + make.id + '-' + model.id
    };
    const userExists = (id, arr) => {
      return arr.some((el) => {
        return el.id == id;
      });
    };
    let array: any = localStorage.getItem('vehicleAdded') ? JSON.parse(localStorage.getItem('vehicleAdded')) : [];
    if (array.length == 5) {
      return;
    }
    if (array.length > 0) {
      if (!userExists(search.id, array)) {
        array.unshift(search);
      }
    } else {
      array.unshift(search);
    }
    localStorage.setItem('vehicleAdded', JSON.stringify(array));
  }


  setAddVehicleData(data): void {
    this.savedAddVehicle = data;
    if (this.isUrlVehicleUrltoBeAdded()) {
      if (!this.savedAddVehicle) {
        this.removeYMKPageParamsforVehicle();
      } else {
        this.addYMKPageParamsforVehicle();
      }

    }
  }


  getSelectedVehicleData() {
    return this.savedAddVehicle && Object.keys(this.savedAddVehicle).length > 0 ? this.savedAddVehicle : null;
  }

  isUrlVehicleUrltoBeAdded(): Boolean {
    return this.seoService.seoData['addMyM']
  }

  addYMKPageParamsforVehicle() {
    if (this.savedAddVehicle && Object.keys(this.savedAddVehicle).length > 0 && this.isUrlVehicleUrltoBeAdded()) {
      // this.addedToURlTree();
      this.updateListWithYMK.next({ status: true });
    }
  }

  addedToURlTree() {
    const urlTree: any = this.router.createUrlTree([], {
      queryParams: {
        make: this.savedAddVehicle.make,
        year: this.savedAddVehicle.year,
        model: this.savedAddVehicle.model,
      },
      queryParamsHandling: 'merge',
      preserveFragment: true
    });
    this.location.replaceState(urlTree);
    this.isVehicleAdded = true;
  }

  removeYMKPageParamsforVehicle() {
    this.removeFromUrlTree();
    this.updateListWithYMK.next({ status: false });
    this.savedAddVehicle = null;
  }

  removeFromUrlTree(): void {
    const urlTree: any = this.router.createUrlTree([], {
      queryParams: {
        make: null,
        year: null,
        model: null,
      },
      queryParamsHandling: 'merge',
      preserveFragment: true
    });
    this.location.replaceState(urlTree);
    this.isVehicleAdded = false;
  }

  setSearchLocalValues(year?, make?, model?, part?) {
    const search = {
      year: year && Object.keys(year).length > 0 ? year : "",
      make: make && Object.keys(make).length > 0 ? make : "",
      model: model && Object.keys(model).length > 0 ? model : ""
    };
    if (part) {
      search['part'] = part && Object.keys(part).length > 0 ? part : "";
    }
    localStorage.setItem('filter', JSON.stringify(search));
  }

  getPartTypeForSearch(year, make, model) {
    let params = "?";
    if (year) {
      params = params.concat("year_id=" + year);
    }
    if (make) {
      params = params.concat("&make_id=" + make);
    }
    if (model) {
      params = params.concat("&model_id=" + model);
    }
    return this.http.get(AppConstants.baseURL + AppConstants.URL_HOME_SEARCH_PART_TYPES + params);
  }

  callSearchPartsApi(year, make, model, pageIndex, searchData): void {
    this.getPartTypeForSearch(year, make, model).subscribe((response) => {
      if (response['status'] == 20 && response['data']['response']) {
        this.emitPartTypeData.next({ status: true, array: response['data']['response'], index: pageIndex, searchData: searchData });
      } else {
        this.emitPartTypeData.next({ status: true, array: [], index: pageIndex, searchData: searchData });
      }
    }, err => {
      this.emitPartTypeData.next({ status: true, array: [], index: pageIndex, searchData: searchData });
    });
  }



  getIsBrowser() {
    return this.isBrowser;
  }



  setMakes(data) {
    this.makes = data;
    this.makesLoaded.emit(true);
  }

  getMakes() {
    return this.makes;
  }

  setPartType(data) {
    this.partType = data;
    this.headerUpdated.emit(this.partType);
  }

  setItem(itemName: string, data: any) {
    this.data[itemName] = "";
    this.data[itemName] = data;
    this.dataUpdated.emit(this.data[itemName]);
  }

  setFilter(key, value) {
    switch (key) {
      case "make":
        this.filter.year = "";
        this.filter.model = "";
        this.filter.engine = "";
        this.filter.part_type = "";
        break;

      case "year":
        this.filter.model = "";
        this.filter.engine = "";
        this.filter.part_type = "";
        break;

      case "model":
        this.filter.engine = "";
        this.filter.part_type = "";
        break;
    }
    this.filter[key] = value;
    this.filterUpdated.emit(this.filter);
  }

  resetFilter() {
    this.filter.make = "";
    this.filter.year = "";
    this.filter.model = "";
    this.filter.sub_model = "";
    this.filter.engine = "";
    this.filter.part_type = "";
    localStorage.removeItem("filter");
  }

  updateSearchFilter_local(key, value) {
    // console.log(key, value);
    let filter = JSON.parse(localStorage.getItem('filter')) || {};
    filter[key] = value;
    localStorage.setItem("filter", JSON.stringify(filter));
  }

  getItem(itemName: string) {
    return this.data[itemName] ? this.data[itemName] : "";
  }

  getCompleteData() {
    return this.data ? this.data : "";
  }

  getPartType() {
    return this.partType ? this.partType : "";
  }

  getFilter() {
    return this.filter ? this.filter : "";
  }

  getOrderData() {
    return this.orderData ? this.orderData : "";
  }

  initRefresh() {
    this.refreshData.emit(true);
  }

  getFilterLocal() {
    let valid_filter = this.isValidJson(localStorage.getItem("filter"));
    if (valid_filter) {
      return JSON.parse(localStorage.getItem("filter"));
    } else {
      return null;
    }
  }

  isValidJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      localStorage.setItem(str, "");
      return false;
    }
    return true;
  }


  getCategories() {
    return this.categories ? this.categories : "";
  }

  getShippingOptions() {
    return this.shippingOptions ? this.shippingOptions : "";
  }

  getDataFromAPI(make?, year?, model?, engine?) {
    let params = "?";
    if (make) {
      params = params.concat("make=" + make);
    }
    if (year) {
      params = params.concat("&year=" + year);
    }
    if (model) {
      params = params.concat("&model=" + model);
    }
    if (engine) {
      if (engine === -1) {
        engine = null;
      }
      params = params.concat("&engine=" + engine);
    }
    return this.http.get(AppConstants.baseURL + AppConstants.URL_APPLICATION_FILTER + params);
  }

  setOrderData(data) {
    this.orderData = data;
  }

  performLogin(params?) {
    if (params) {
      this.performLoginTrigger.emit(params);
    } else {
      this.performLoginTrigger.emit();
    }
  }

  showCartPopup(event, target?) {
    this.showCartPopupTrigger.emit([event, target]);
  }

  showMobileCartPopup(offset?) {
    if (offset) this.showCartMobileTrigger.emit(offset);
    else this.showCartMobileTrigger.emit();
  }

  triggerPopupClose() {
    this.popupCloseTrigger.emit();
  }

  triggerPopupOk() {
    this.popupOkTrigger.emit();
  }



  clearLocalStorage() {
    localStorage.removeItem("data");
    localStorage.removeItem("filter");
  }

  openOrderStatusForm() {
    this.showOrderStatusTrigger.emit();
  }

  emitEventToShowPopUpInHomePage(context) {
    this.showPopUpInHomePageTrigger.emit(context);
  }

  emitChatPopupTrigger() {
    this.showChatPopupTrigger.emit(true);
  }

  emitChatPopupActiveTrigger() {
    this.activeChatPopupTrigger.emit(true);
  }

  setZipCode(zipCode) {
    this.zipCode = zipCode || "";
    if (zipCode) {
      localStorage.setItem("zipCode", zipCode)
    }
  }

  getZipCode() {
    return localStorage.getItem("zipCode") || null
  }

  getIPLocationData() {
    return localStorage.getItem("location") || null
  }

  setIPLocationData(data: object) {
    localStorage.setItem('location', JSON.stringify(data));
  }

  getIPLocationInfo() {
    return this.http.get(AppConstants.baseURL + "/common_content/get_coordinates_from_ip");
    // return this.http.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${AppConstants.GOOGLE_API_KEY}`, JSON.stringify(body));
  }

  // Default keyboard Selection for p-dropdown on type with only one value

  enterKeySelection(id, styleclass) {
    const element = document.getElementById(id);
    if (element) {
      const input = element.querySelector('.ui-dropdown-filter-container input') as any;
      const nodeElement = element.querySelectorAll('.ui-dropdown-items-wrapper .ui-dropdown-list p-dropdownitem') as any;
      if (input && input.value && nodeElement && nodeElement.length == 1) {
        (element.querySelector(`.${styleclass}`) as any).click();
        setTimeout(() => {
          const totalElement1 = element.querySelectorAll('.ui-dropdown-items-wrapper .ui-dropdown-list p-dropdownitem') as any;
          for (let i = 0; i < totalElement1.length; i++) {
            totalElement1[i].querySelector('li').click();
          }
        });
      }
    }
  }


  resetAfterSelection(id) {
    id.filterValue = '';
    id.optionsToDisplay = id.options;
  }

  // Vehicle Fitment

  getVehicleFitmentDetails(isLogged, is_product_page, item_id, item_type, make, year, model, sub_model_id, engine_id, fitment?, common?, specific?, drive_type_id?, transmission_id?) {
    let url, data, headers;
    if (isLogged) {
      headers = new HttpHeaders().set("Auth", "Bearer " + localStorage.getItem("access_token"));
    }
    url = 'part_applications/search_vehicle_fitment';
    if (is_product_page) {
      url += "?&is_product_page=" + is_product_page;
    }
    if (item_id) {
      url += "&item_id=" + item_id;
    }
    if (item_type) {
      url += "&item_type=" + item_type;
    }
    if (make) {
      url += "&make=" + make;
    }
    if (year) {
      url += "&year=" + year;
    }
    if (model) {
      url += "&model=" + model;
    }
    if (sub_model_id) {
      url += "&sub_model_id=" + sub_model_id;
    }
    if (engine_id) {
      url += "&engine_id=" + engine_id;
    }
    if (drive_type_id) {
      url += "&drive_type_id=" + drive_type_id;
    }
    if (transmission_id) {
      url += "&transmission_id=" + transmission_id;
    }

    if (item_type == 'part') {
      if (fitment && Object.keys(fitment).length > 0) {
        data = { "fitment_filters": fitment };

      }
    } else {
      if ((common && Object.keys(common).length > 0) || (specific && Object.keys(specific).length > 0)) {
        data = { "common_fitment_filters": common, "specific_fitment_filters": specific };
      }
    }
    return this.http.post(AppConstants.baseURL + url, data, { headers: headers ? headers : null });

  }


  submitVehicleFitment(isLogged, params) {
    let headers;
    if (isLogged) {
      headers = new HttpHeaders().set("Auth", "Bearer " + localStorage.getItem("access_token"));
    }
    return this.http.post(AppConstants.baseURL + 'part_catalogs/vehicle_fitment_check', params, { headers: headers ? headers : null });
  }

  submitCallRequestData(params) {
    return this.http.post(AppConstants.baseURL + '/fitment_check_queries', { 'fitment_check': params });
  }



  redirectToPage(element): string {
    const a = document.createElement("a");
    a.href = element;
    return a['pathname'];
  }



  // GA Analytics

  // cart

  pushGACart(productsArr: Array<ProductsArrInterface>) {
    let products = [];

    productsArr.forEach(prd => {
      let prd_ref = {
        name: prd.name,
        id: prd.id,
        price: Number(prd.price),
        brand: prd.brand || '',
        category: "",
        variant: "",
        quantity: prd.quantity || 1,
      }
      products.push(prd_ref)
    });

    (<any>window).dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    (<any>window).dataLayer.push({
      event: "addToCart",
      ecommerce: {
        currencyCode: "USD",
        add: {
          products: products,
        },
      },
    });
  }

  pushDataToGoogleAnalyticsCart(shippingData, payment_method): void {
    if (!shippingData || shippingData.length == 0) {
      return;
    }
    (<any>window).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    (<any>window).dataLayer.push({
      'event': 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': { 'step': 1, 'option': payment_method },
          'products': shippingData.map(part => {
            let d = {};
            d["name"] = part["title"];
            d["id"] = part["item_number"];
            d["price"] = part["price"];
            d["brand"] = part["brand"] || "";
            d["category"] = part["category"] || "";
            d["variant"] = part["part_type"] || "";
            d["quantity"] = part["quantity"];
            return d;
          })
        }
      }
    });
  }


  // Checkout

  pushDataToGoogleAnalytics(step, shippingData, orderDetails): void {
    if (!shippingData || shippingData.length == 0) {
      return;
    }
    let products = shippingData.flatMap(shippingGroup => {
      return shippingGroup.parts.map(part => {
        let d = {};
        d["name"] = part["title"];
        d["id"] = part["item_number"];
        d["price"] = part["price"];
        d["brand"] = part["brand"] || "";
        d["category"] = part["category"] || "";
        d["variant"] = part["part_type"] || "";
        d["quantity"] = part["cart_quantity"];
        return d;
      });
    });
    (<any>window).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    (<any>window).dataLayer.push({
      'event': 'checkout',
      'ecommerce': {
        'checkout': {
          'actionField': { 'step': step, 'option': orderDetails.payment_method },
          'products': products
        }
      }
    });
  }

  pushPurchaseDataToGoogleAnalytics(orderDetails) {
    let data = orderDetails["response"];
    let order_numbers = data.map(elem => elem["order_number"]).join(", ");
    let total = data
      .map(elem => parseFloat(elem["total"]))
      .reduce((a, b) => a + b, 0)
      .toString();
    let tax = data
      .map(elem => parseFloat(elem["tax"]))
      .reduce((a, b) => a + b, 0)
      .toString();
    let shipping_cost = data
      .map(elem => parseFloat(elem["shipping_cost"]))
      .reduce((a, b) => a + b, 0)
      .toString();
    let productsArray = [].concat.apply([], data.map(elem => elem["order_parts"])); // Flatten array of order_parts arrays
    let products = productsArray.map(elem => {
      return {
        id: elem["item_number"],
        name: elem["title"],
        price: elem["price"],
        category: elem["category"] || "",
        variant: elem["part_type"] || "",
        quantity: elem["quantity"],
        brand: elem["brand"] || ""
      };
    });
    (<any>window).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    (<any>window).dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': order_numbers,                         // Transaction ID. Required for purchases and refunds.
            'affiliation': 'AutoBuffy',
            'revenue': total,                     // Total transaction value (incl. tax and shipping)
            'tax': tax,
            'shipping': shipping_cost,
            'coupon': ''
          },
          'products': products
        }
      }
    });
  }

   // reviews 

   getUserReviews(limit, offset)
   {
      let params = "?is_home_page=true";
      if (limit) {
        params = params.concat("&limit=" + limit + "&offset=" + offset);
      }
     return this.http.get(AppConstants.baseURL + 'reviews' + params);
   }
   getPilotReviews (limit, offset)
   {
     const headers = new HttpHeaders()
     let params = "?is_trust_pilot_reviews=true";
      if (limit) {
        params = params.concat("&limit=" + limit + "&offset=" + offset);
      }
     return this.http.get(AppConstants.baseURL + 'customer_reviews' + params);
   }
  
   triggerLinkClicked() {
     this.linkClickedSource.next(true);
  }


}
